import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { http, currency, API } from "../lib/api";
import { ArrowRight } from "lucide-react";

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const cat = searchParams.get("cat") || "";

  useEffect(() => {
    http.get("/categories").then((r) => setCategories(r.data)).catch(() => setCategories([]));
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = cat ? { category: cat } : {};
    http.get("/products", { params })
      .then((r) => setProducts(r.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [cat]);

  const productImage = (p) => {
    if (p.images && p.images.length) {
      const first = p.images[0];
      return first.startsWith("http") ? first : `${API}/files/${first}`;
    }
    return p.base_image_url;
  };

  const filters = [{ value: "", label: "Todos" }, ...categories.map((c) => ({ value: c.slug, label: c.name }))];

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12" data-testid="shop-page">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-neutral-500 mb-2">/tienda</div>
          <h1 className="font-display text-5xl md:text-6xl tracking-tighter">Catálogo</h1>
        </div>
        <div className="flex gap-1 border border-neutral-200 bg-white p-1 flex-wrap" data-testid="shop-filters">
          {filters.map((c) => (
            <button
              key={c.value || "all"}
              onClick={() => setSearchParams(c.value ? { cat: c.value } : {})}
              className={`px-4 py-2 text-sm font-medium transition-colors ${
                cat === c.value ? "bg-black text-white" : "hover:bg-neutral-100"
              }`}
              data-testid={`shop-filter-${c.value || "all"}`}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {[1,2,3,4,5,6,7,8].map((i) => (
            <div key={i} className="brutal-card aspect-[4/5] animate-pulse bg-neutral-100" />
          ))}
        </div>
      ) : products.length === 0 ? (
        <div className="brutal-card p-16 text-center" data-testid="shop-empty">
          <p className="text-neutral-500">No hay productos en esta categoría.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="shop-products-grid">
          {products.map((p) => (
            <Link
              key={p.product_id}
              to={`/producto/${p.product_id}`}
              className="brutal-card group hover:-translate-y-1 transition-transform"
              data-testid={`shop-product-${p.product_id}`}
            >
              <div className="aspect-[4/5] overflow-hidden bg-neutral-100">
                <img src={productImage(p)} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
              </div>
              <div className="p-4">
                <div className="text-xs font-mono uppercase text-neutral-500 mb-1">{p.category}</div>
                <div className="font-medium text-sm leading-snug">{p.name}</div>
                <div className="flex items-center justify-between mt-3">
                  <span className="font-display text-xl">{currency(p.base_price)}</span>
                  <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
